import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  InputSignal,
  InputSignalWithTransform,
  Signal
} from '@angular/core';
import { IonicModule } from '@ionic/angular';

export type OrIconSize = 'xxs' | 'xs' | 's' | 'm' | 'l' | 'xl';

@Component({
  selector: 'or-icon',
  standalone: true,
  imports: [IonicModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<ion-icon [src]="src()"></ion-icon>`,
  styleUrls: ['./or-icon.component.scss'],
  host: {
    '[class.or-icon-xxs]': "size() === 'xxs'",
    '[class.or-icon-xs]': "size() === 'xs'",
    '[class.or-icon-s]': "size() === 's'",
    '[class.or-icon-m]': "size() === 'm'",
    '[class.or-icon-l]': "size() === 'l'",
    '[class.or-icon-xl]': "size() === 'xl'",
    '[class.or-icon--box]': 'boxed()',
    '[class.or-icon--square]': 'square()',
    '[class.or-icon--circle]': 'circle()'
  }
})
export class OrIconComponent {
  readonly name: InputSignal<string> = input.required<string>();
  readonly size: InputSignal<OrIconSize> = input<OrIconSize>('m');
  readonly boxed: InputSignalWithTransform<boolean, unknown> = input(false, { transform: booleanAttribute });
  readonly square: InputSignalWithTransform<boolean, unknown> = input(false, { transform: booleanAttribute });
  readonly circle: InputSignalWithTransform<boolean, unknown> = input(false, { transform: booleanAttribute });
  readonly folder: InputSignal<string> = input<string>('v2');

  readonly src: Signal<string> = computed(() => `assets/icons/${this.folder()}/${this.name()}.svg`);
}
